import { Box } from "@mui/system";
import React, { useState } from "react";
import Toast from "../../components/ui/Toast";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import InputLabelComp from "../../components/ui/InputLabelComp";
import { InputField } from "../../components/ui/Inputs";
import {
  PrimaryButton,
  PrimaryButtonText,
  SecondaryButtonText,
} from "../../components/ui/Button";
import ButtonLoader from "../../components/ui/ButtonLoader";
import service from "../../services/api/service";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import { useDispatch } from "react-redux";
import { encrypt } from "../../utils/crypto";
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { ROUTES } from "../../routes/routerConfig";
import {
  addKey,
  addLanNumber,
  addMobileNumber,
  setLoginType,
} from "../../services/redux/slices/keyRegistrarSlice";
import { ArrowBack } from "@mui/icons-material";
import { setOtpUserData } from "../../services/redux/slices/authSlice";
import { emailRegex } from "../../utils/helpers";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import loginBottomBanner2 from "../../assets/images/auth/market-button.svg";
import loginBottomBanner3 from "../../assets/images/auth/market-button-play.svg";

type Props = {
  setNextStep: (step: string) => void;
};
type Inputs = {
  loan_number: string;
  email: string;
  selectField: string;
  multiSelectField: Array<{ label: string; value: string }>; // Add this for multi-select
};

const Register = ({ setNextStep }: Props) => {
  const dispatch = useDispatch();

  const [toastOpen, setToastOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");

  const handleToastClose = () => setToastOpen(false);
  const { control, handleSubmit, watch } = useForm<Inputs>({
    defaultValues: {
      loan_number: "",
      email: "",
      selectField: "",
      multiSelectField: [],
    },
  });

  const [selected, setSelected] = useState("register");

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newSelection: string
  ) => {
    if (newSelection !== null) {
      setSelected(newSelection);
      setNextStep(ROUTES?.Login?.index);
    }
  };

  const buttonDisable: boolean =
    !!watch("loan_number")?.length && !!watch("email")?.length;

  const onKeyDownHandler = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      // Prefer 'e.key' over 'e.keyCode'
      e.preventDefault(); // Prevent default form submission behavior
      handleSubmit(onSubmit)(); // Properly invoke handleSubmit with the onSubmit handler
    }
  };
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    dispatch(addKey("register"));
    setIsLoading(true);
    dispatch(addLanNumber(data?.loan_number));
    if (emailRegex.test(data?.email)) {
      dispatch(setLoginType("email"));
      console.log("The input is a mobile number:", data?.email);
    } else {
      dispatch(setLoginType("mobile"));
      console.log("The input is a mobile number:", data?.email);
      // Handle mobile login
    }

    dispatch(addMobileNumber(data?.email));
    const selectedOptions = data.multiSelectField;

    dispatch(setOtpUserData(data?.email));
    const payload = {
      lan: encrypt(data.loan_number),
      key: encrypt(data?.email),
    };
    service?.auth
      ?.sendRegisterOtp(payload)
      .then((res) => {
        setNextStep(ROUTES?.Login?.otp?.path);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        dispatch(
          setStatusPopup({
            status: "error",
            // message: `Disbursement requests are not permitted for this loan.`,
            message: errorMessage,
          })
        );
        setIsLoading(false);
      });
  };

  const handleBack = () => setNextStep("");

  return (
    <Box>
      <Toast
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleToastClose}
      />
      {/* <Box className="sub-heading">
        <PrimaryButtonText
          startIcon={<ArrowBack color="inherit" fontSize="small" />}
          onClick={handleBack}
        >
          Back
        </PrimaryButtonText>
      </Box>{" "} */}
      <Box className="main-wrapper">
        <Box className="head-section" sx={{ width: ["100%", "-webkit-fill-available"] }}>
          <Box className="heading">Let’s Start!👋</Box>
          {/* <Box className="heading">Register Now</Box> */}

          <ToggleButtonGroup
            value={selected}
            exclusive
            onChange={handleChange}
            sx={{
              height: "40px",
              backgroundColor: "#eaf3f5", // container bg
              borderRadius: "7px",
              padding: "4px",
              display: "inline-flex",
              border: "none", // remove group border
              width: "100%",
              gap: "6px",
              marginTop: "10px"
            }}
          >
            <ToggleButton
              value="login"
              component="div" // render as div
              disableRipple
              sx={{
                flex: 1,
                borderRadius: "6px !important", // fully rounded
                textTransform: "none",
                border: "none", // remove inner borders
                "&.Mui-selected": {
                  backgroundColor: "#ffffff",
                  color: "#0e8a9e",
                  boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                },
                "&:hover": {
                  backgroundColor: "#ffffff",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#ffffff", // Ensures no hover effect when selected
                },
                "&.Mui-focusVisible": {
                  backgroundColor: "#ffffff",
                },
              }}
            >
              Login
            </ToggleButton>
            <ToggleButton
              disableRipple
              component="div" // render as div
              value="register"
              sx={{
                flex: 1,
                borderRadius: "6px !important", // fully rounded
                textTransform: "none",
                border: "none", // remove inner borders
                "&.Mui-selected": {
                  backgroundColor: "#ffffff",
                  color: "#0e8a9e",
                  boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                },
                "&:hover": {
                  backgroundColor: "#ffffff",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#ffffff", // Ensures no hover effect when selected
                },
                "&.Mui-focusVisible": {
                  backgroundColor: "#ffffff",
                },
              }}
            >
              Register
            </ToggleButton>
          </ToggleButtonGroup>


          <Box className="sub-heading" sx={{ paddingTop: "10px" }}>
            Please enter your details to get registered.
          </Box>
        </Box>
        {/* <form> */}
        <Grid container spacing={2}>
          {/* Grid container for layout */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box mb={2}>
              <Controller
                name="loan_number"
                control={control}
                render={({ field }) => (
                  <>
                    <InputLabelComp title="Loan Account Number " css={false} />
                    <InputField
                      {...field}
                      // autoFocus
                      fullWidth
                      borderRadius="6px"
                      placeholder="Enter Loan Account Number"
                      autoComplete="off"
                      onKeyDown={(e: any) => onKeyDownHandler(e)}
                    />
                  </>
                )}
              />
            </Box>
            {/* Input for Mobile Number */}

            <Controller
              name="email"
              control={control}
              // rules={{
              //   pattern: {
              //     value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              //     message: "Invalid email address",
              //   },
              // }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <InputLabelComp
                    title="Mobile Number or Email ID"
                    css={false}
                  />
                  <InputField
                    {...field}
                    fullWidth
                    borderRadius="6px"
                    placeholder="Enter Mobile Number or Email ID"
                    autoComplete="off"
                    onKeyDown={(e: any) => onKeyDownHandler(e)}
                    error={!!error}
                  />
                  {error && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {error.message}
                    </span>
                  )}
                </>
              )}
            />
          </Grid>
        </Grid>
        <PrimaryButton
          type="button"
          fullWidth
          //endIcon={<ArrowForward color="inherit" fontSize="small" />}
          onClick={handleSubmit(onSubmit)}
          disabled={!buttonDisable || isLoading}
        >
          <ButtonLoader title="Continue" isLoading={isLoading} />
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default Register;